import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';

import breakpoints from '../util/breakpoints';

const ThisCol = styled(Col)`
  padding: 0;
`;

const ThisNavbar = styled(Navbar)`
  padding: 5px 0 0 0;
`;

const ThisNavbarBrand = styled(NavbarBrand)`
  background-image: url('/images/logo.svg');
  background-repeat: no-repeat;
  margin: 10px 0 0 20px;
  padding-left: 50px;

  h1 {
    font-size: 0.8em;
    font-weight: 700;
  }

  ${breakpoints.md`
    margin-left: 0px;
  `}
`;

const ThisNavbarToggler = styled(NavbarToggler)`
  margin: 10px;
  border: none;
  outline: 0 !important;

  span {
    width: 40px;
    height: 40px;
  }
`;

const ThisNav = styled(Nav)`
  background: linear-gradient(to bottom, rgba(29, 31, 53, 0) 0%, rgba(29, 31, 53, 0.7) 20%, rgba(29, 31, 53, 1) 100%);
  position: relative;
  z-index: 1;
`;

const ThisNavItem = styled(NavItem)`

  &:last-child {
    padding-bottom: 30px;

    ${breakpoints.md`
      padding-bottom: 0px;
    }
  `}
`;

const ThisNavLink = styled(NavLink)`
  margin-left: 20px;
  padding: 20px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.2em;

  font-size: 1.3em;

  transition: color 0.5s;

  &.active span {
    color: white;
    padding-bottom: 7px;
    border-bottom: 2px solid white;
  }

  &:hover {
    text-decoration: none;
    color: #89e7c6 !important;
  }

  ${breakpoints.md`
    font-size: 0.8em;
  `}
`;

class Header extends React.Component {

  state = {
    isOpen: false,
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <Container>
        <Row>
          <ThisCol>
            <ThisNavbar dark expand="md">
              <ThisNavbarBrand to="/" tag={RRNavLink}>
                <h1>two's complement</h1>
              </ThisNavbarBrand>
              <ThisNavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <ThisNav className="ml-auto" navbar>
                  <ThisNavItem>
                    <ThisNavLink to="/work" tag={RRNavLink}><span>work</span></ThisNavLink>
                  </ThisNavItem>
                  <ThisNavItem>
                    <ThisNavLink href="https://goo.gl/forms/gIYRCpY808iKFbiS2" target="_blank">start a project</ThisNavLink>
                  </ThisNavItem>
                </ThisNav>
              </Collapse>
            </ThisNavbar>
          </ThisCol>
        </Row>
      </Container>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js